module.exports = __webpack_public_path__ + "static/media/abs-hotline.25a43d89.jpeg";